import * as actionType from '../actionTypes';

const initialState = {
    logs: ''
}
const logs = (state = initialState, action) => {
    // debugger;
    switch (action.type) {
        case actionType.LOGS:
            return {
                ...state,
                logs: action.data
            };
        case actionType.LOGS_CLEAR:
            return {};
        default:
            return state
    }
}
export default logs;